import * as Q from "q";
import * as VSS_Telemetry from "VSS/Telemetry/Services";
import * as Utils_String from "VSS/Utils/String";
import * as TFS_Core_Ajax from "Presentation/Scripts/TFS/TFS.Legacy.Ajax";
import * as SecurityModels from "Account/Scripts/TFS.Details.Security.Common.Models";
import * as AccountResources from "Account/Scripts/Resources/TFS.Resources.Account";
import {
    PatTokenDataPayload,
} from "VersionControl/Scenarios/NewGettingStarted/ActionsHub";
import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";
import * as CustomerIntelligenceConstants from "VersionControl/Scripts/CustomerIntelligenceConstants";
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";

export class GitCredentialsSource {
    constructor(
        private _patTokensRootUrl: string,
        private _patUsername: string,
        private _collectionUri: string,
        private _collectionId: string,
        private _tokenExpirationDays: string, 
    ) { }

    /*
     * Logic to create a personal access token.
     */
    public getPatTokenData(): IPromise<PatTokenDataPayload> {
        const deferred = Q.defer<PatTokenDataPayload>();

        VSS_Telemetry.publishEvent(new VSS_Telemetry.TelemetryEventData(
            CustomerIntelligenceConstants.VERSION_CONTROL_AREA,
            CustomerIntelligenceConstants.CREATE_PAT,
            {})
        );

        const currentPatModel = this._getCurrentPatModel();

        //Make a server call to the tokens endpoint to create the PAT.
        TFS_Core_Ajax.postMSJSON(
            Utils_String.format("{0}/{1}", this._patTokensRootUrl, "Edit"),
            currentPatModel,
            (data: SecurityModels.PersonalAccessTokenDetailsModel) => this._resolvePatTokenDataRequest(data, deferred),
            (error: Error) => this._rejectPatTokenDataRequest(error, deferred)
        );

        return deferred.promise;
    }

    private _resolvePatTokenDataRequest = (
        data: SecurityModels.PersonalAccessTokenDetailsModel,
        deferred: Q.Deferred<PatTokenDataPayload>,
    ): void => {
        if (data) {
            deferred.resolve({
                patUsername: this._patUsername,
                patPassword: data.Token,
            });
        } else {
            //If data is null we resolve undefined. It'll take the user to patTokensRootUrl.
            deferred.resolve(undefined);
        }
    }

    private _rejectPatTokenDataRequest = (error: Error, deferred: Q.Deferred<PatTokenDataPayload>): void => {
        let errorMessage: string;
        if (error && error.message) {
            errorMessage = Utils_String.htmlDecode(error.message);

            if (FeatureAvailabilityService.isFeatureEnabled("WebAccess.Wiki.Clone.NewPATPolicy", false) && errorMessage.toUpperCase() == "PATLIFESPANPOLICYVIOLATION") {
                errorMessage = AccountResources.TokenGenerationFailedDueToLifespan;
            }
        } else {
            errorMessage = AccountResources.TokenGenerationFailed;
        }

        deferred.reject(new Error(errorMessage));
    }

    private _getCurrentPatModel(): SecurityModels.EditTokenData {
        const data = new SecurityModels.EditTokenData();

        // Description
        data.Description = Utils_String.format(VCResources.GitPersonalAccessTokenFormat, this._collectionUri);

        // Expiration Date
        data.SelectedExpiration = this._tokenExpirationDays;

        // Create the token for this specific account.
        data.AccountMode = "SelectedAccounts";
        data.SelectedAccounts = this._collectionId;

        // Scopes
        data.ScopeMode = "SelectedScopes";
        data.SelectedScopes = "vso.code_write";

        // Antiforgery Token
        data.__RequestVerificationToken = $("input[name=__RequestVerificationToken]").val();

        // Id for edit/create
        data.AuthorizationId = Utils_String.empty;

        return data;
    }
}